/**
 * Locale routing registry — keep in sync with GuidePage (Ruby) and Seo::HreflangRegistry.
 * See docs/seo-hreflang.md.
 */

/** Guide EN/VI slug pairs (path segment after /guides/). */
export const GUIDE_SLUG_PAIRS = [
  {
    key: "auspicious",
    en: "wedding-auspicious-dates",
    vi: "ngay-cuoi-hop-tuoi-cach-chon-ngay-dep",
  },
  {
    key: "lunar",
    en: "wedding-lunar-and-solar-calendars",
    vi: "lich-am-duong-va-ngay-cuoi",
  },
  {
    key: "elements",
    en: "wedding-date-elements-and-signs-checklist",
    vi: "ngu-hanh-cung-ho-voi-ngay-cuoi",
  },
];

/** Paths that exist only in English (no /vi equivalent). */
export const EN_ONLY_PATH_PREFIXES = ["/articles"];

export function weddingGuidePaths(locale) {
  const pairByKey = Object.fromEntries(GUIDE_SLUG_PAIRS.map((p) => [p.key, p]));
  if (locale === "vi") {
    return {
      auspicious: `/vi/guides/${pairByKey.auspicious.vi}`,
      lunar: `/vi/guides/${pairByKey.lunar.vi}`,
      elements: `/vi/guides/${pairByKey.elements.vi}`,
    };
  }
  return {
    auspicious: `/guides/${pairByKey.auspicious.en}`,
    lunar: `/guides/${pairByKey.lunar.en}`,
    elements: `/guides/${pairByKey.elements.en}`,
  };
}

export function guideSlugForLocale(slug, targetLocale) {
  const normalized = slug?.toString().trim();
  if (!normalized) return null;
  for (const pair of GUIDE_SLUG_PAIRS) {
    if (pair.en === normalized) return targetLocale === "vi" ? pair.vi : pair.en;
    if (pair.vi === normalized) return targetLocale === "vi" ? pair.vi : pair.en;
  }
  return null;
}

export function isEnOnlyPath(pathname) {
  const path = pathname?.toString() || "";
  return EN_ONLY_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
